import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { TransactionsContainer } from "@/screens/Accounting/subfeatures/Transactions"
import { transactionsSearchParamsSchema } from "@/screens/Accounting/subfeatures/Transactions/types/searchParams"

export const Route = createFileRoute("/app/accounting/_layout/gl-transactions")({
  validateSearch: transactionsSearchParamsSchema,
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "transactionType", "dateType", "dateFrom", "dateTo"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.GL_TRANSACTION_VIEW]}>
      <TransactionsContainer />
    </PermissionContentWrapper>
  ),
})
